import React from "react";

import { Truncated } from "~/components/truncated";
import { cv } from "~/tools/class-variance";
import { toEntries } from "~/tools/to-entries";
import { toJSON } from "~/tools/to-json";
import { toKeys } from "~/tools/to-keys";

import { formatDurationSeconds } from "./_format-duration-seconds";
import type { ToolCallPartType } from "./_part-types";
import { ToolStatusBadge } from "./_tool-status-badge";

const toolCallBorderVariants = cv("flex flex-col gap-1 border-gray-400 border-l-2 pl-2", {
	variants: {
		status: {
			complete: "border-green-400",
			failed: "border-red-400",
		},
	},
});

export const ToolCallDetail: React.FC<{ part: ToolCallPartType }> = ({ part }) => (
	<div
		className={toolCallBorderVariants({
			className: undefined,
			status: part.tool_status === "complete" || part.tool_status === "failed" ? part.tool_status : undefined,
		})}
	>
		<div className="flex items-center gap-2">
			<span className="font-mono text-gray-800 text-xs">{part.tool_name}</span>
			{part.duration_ms != null && (
				<span className="text-gray-500 text-xs">({formatDurationSeconds(part.duration_ms)})</span>
			)}
			<ToolStatusBadge status={part.tool_status} />
		</div>
		{part.tool_args != null && toKeys(part.tool_args).length > 0 && (
			<div className="flex flex-col gap-0.5">
				{toEntries(part.tool_args).map(([key, value]) => (
					<div className="flex gap-1 font-mono text-11 text-gray-500" key={key}>
						<span className="shrink-0">{key}:</span>
						<Truncated className="flex-1">{typeof value === "string" ? value : toJSON(value)}</Truncated>
					</div>
				))}
			</div>
		)}
	</div>
);
